import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../Components/ComboBox'
import FileUploadIcon from '@mui/icons-material/FileUpload'

import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'

import { styled } from '@mui/material/styles'
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const Input = styled('input')({
  display: 'none',
})

export default function UploadOperations({ account = null, update = null }) {
  const [open, setOpen] = useState(false)
  const [accounts, setAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState([])
  const [numeroCompte, setNumeroCompte] = useState(null)
  const [file, setFile] = useState(null)
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const fetchAccounts = async () => {
    setNumeroCompte(null)
    setFile(null)
    const { data, status } = await makeGetRequest(urls.fetchAccounts + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterAccounts = []
      data.forEach((v) => {
        if (account && account === v.id) {
          setNumeroCompte(v.id)
          setSelectedAccount({
            label: `${v.TypeCompte?.TypeCompte} - ${v.Nom?.Nom} - ${v.NumeroCompte}`,
            id: v.id,
          })
        }
        filterAccounts.push({
          label: `${v.TypeCompte?.TypeCompte} - ${v.Nom?.Nom} - ${v.NumeroCompte}`,
          id: v.id,
        })
      })
      setAccounts([...filterAccounts])
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    fetchAccounts()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (numeroCompte === null || numeroCompte === '' || file === '' || file === null) {
      alert(t('finance.gestionOperations.selectAccount'))
    } else {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('NumeroCompte', numeroCompte)
      const response = await makePostRequest(
        urls.addBulkOperations,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
        true,
      )
      if (response.status === 201 || response.status === 200) {
        handleClose()
        if (account && update) {
          update()
        }
      }
    }
  }

  return (
    <>
      {isMobile ? (
        <Box onClick={handleClickOpen}>{t('finance.gestionOperations.importData')}</Box>
      ) : (
        <CustomButton onClick={handleClickOpen}>{t('finance.gestionOperations.importData')}</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('finance.gestionOperations.importOperationsTitle')}</DialogTitle>
        <form onSubmit={onSubmit}>
          <DialogContent>
            {account ? (
              <ComboBox
                handleAutoComplete={(e, j) => setNumeroCompte(j.id)}
                label={t('finance.gestionOperations.accountName')}
                readOnly
                data={accounts}
                selectedValue={selectedAccount}
                name="NumeroCompte"
              />
            ) : (
              <ComboBox
                handleAutoComplete={(e, j) => setNumeroCompte(j.id)}
                label={t('finance.gestionOperations.accountName')}
                data={accounts}
                name="NumeroCompte"
              />
            )}
            <label htmlFor="contained-button-file2">
              <Input
                accept="/*"
                id="contained-button-file2"
                onChange={(e) => setFile(e.target.files[0])}
                type="file"
              />
              <Stack mt={2} justifyContent="center" width={'100%'}>
                <Button variant="outlined" component="span" startIcon={<FileUploadIcon />}>
                  {t('finance.gestionOperations.uploadCsv')}
                </Button>
              </Stack>
            </label>
            <br />
            <a href="/csv2.csv">{t('finance.gestionOperations.templateCsv')}</a>
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('finance.common.confirm')}</Button>
            <Button onClick={handleClose}>{t('finance.common.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
